if (!window.customElements.get('tooltip-component')) {
  class ToolTip extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.openButton = this.querySelector('[data-tooltip-open]');
      this.closeButton = this.querySelector('[data-tooltip-close]');
      this.modal = this.querySelector('[data-tooltip-modal]');
      this.modalContent = this.querySelector('[data-tooltip-modal-content]');
      this.productDetails = this.closest('[data-product-details]');
      this.checkModalContent();
      this._onOpen = () => this.open();
      this._onClose = () => this.close();
      this._documentClose = (event) => this.documentClose(event);
      document.addEventListener('click', (event) => this._documentClose(event));
      this.openButton?.addEventListener('click', this._onOpen);
      this.closeButton?.addEventListener('click', this._onClose);
    }

    disconnectedCallback() {
      document.removeEventListener('click', (event) => this._documentClose(event));
      this.openButton?.removeEventListener('click', this._onOpen);
      this.closeButton?.removeEventListener('click', this._onClose);
    }

    open() {
      if (!this.modal) return;
      if (this.modal.classList.contains('active')) {
        this.close();
      } else {
        this.modal.classList.add('active');
        this.modal.setAttribute('aria-hidden', 'false');
        this.openButton?.setAttribute('aria-expanded', 'true');
        window.trapFocus?.(this.modal);

        if (this.productDetails) {
          this.productDetails.classList.remove('overflow-hidden');
        }
      }
    }

    close() {
      if (!this.modal) return;
      this.modal.classList.remove('active');
      this.modal.setAttribute('aria-hidden', 'true');
      this.openButton?.setAttribute('aria-expanded', 'false');
      window.removeTrapFocus?.();
      if (this.productDetails) {
        this.productDetails.classList.add('overflow-hidden');
      }
    }

    documentClose(event) {
      if(!this.modal || event.target.closest('[data-tooltip-modal]') || event.target.closest('[data-tooltip-open]')) return;
      this.modal.classList.remove('active');
      this.modal.setAttribute('aria-hidden', 'true');
      this.openButton?.setAttribute('aria-expanded', 'false');
      window.removeTrapFocus?.();
      if (this.productDetails) {
        this.productDetails.classList.add('overflow-hidden');
      }
    }

    checkModalContent() {
      if (!this.modalContent || !this.modalContent.hasAttribute('data-strip-html')) return;
      this.modalContent.innerHTML = this.modalContent.textContent;
      this.modalContent.removeAttribute('data-strip-html');
    }
  }

  window.customElements.define('tooltip-component', ToolTip);
}
